<div [ngClass]="Theme">

    <ng-container *ngIf="Theme != 'tab-menu-scrollBar' ">
      <ul class="double-tabs">    
        <li *ngFor="let item of Items" [ngClass]="{'active-tab': item.active}" (click)="eventTab($event, item)" style="position: relative;">
          <div class="bg-tab" #bgTab></div>
          <div #textTab>
            <app-text  Theme="BodyRegular" Text="{{item.label}}"></app-text>
          </div>
          <!-- <app-skeletoons body-content loading Theme="skeletoons-primary" [Radius]="10" *ngIf="load_Data"></app-skeletoons> -->
        </li>      
      </ul>
    </ng-container>
  
    <ng-container *ngIf="Theme === 'tab-menu-scrollBar' ">
      <p-scrollPanel styleClass="scroll-colmena-2">
        <ul class="double-tabs">    
          <li *ngFor="let item of Items" [ngClass]="{'active-tab': item.active}" (click)="eventTab($event, item)" style="position: relative;">
            <div class="bg-tab" #bgTab></div>
            <div #textTab>
              <app-text  Theme="BodyRegular" Text="{{item.label}}"></app-text>
            </div>
            <!-- <app-skeletoons body-content loading Theme="skeletoons-primary" [Radius]="10" *ngIf="load_Data"></app-skeletoons> -->
          </li>      
        </ul>
      </p-scrollPanel>  
    </ng-container>
  </div>